import React from "react";
import {useState, useEffect} from "react";
import '../css/nav.css';
import Logo from './../img/logo/main_logo.png';
import NavMenu from "../layout/nav_menu";

import { AnimatePresence } from 'framer-motion';



function Nav() {
    const [navBar, setNavBar] = useState(false);
    const [openMenu, setOpenMenu] = useState(false);

    useEffect(() => {
         if (window.location.pathname !== '/') {
        setNavBar(true)
         };



    }, [setNavBar] );
   

    const changeBg = () => {
        setOpenMenu(false);
        if (window.location.pathname !== '/' || window.scrollY >= 80 ) {
            setNavBar(true)
        } else {
            setNavBar(false)
        }
       
    };

   
    window.addEventListener('scroll', changeBg);
    return (
        <>
        <div className={navBar ? 'nav__bg' : ''}>
            <div className="container nav__container"> 
                <div className='nav__img'>
                    <a href={window.location.pathname !== '/' ? "/" : "#Home"}>
                        <img src={Logo} alt='nav logo' />
                    </a>

                </div>

                <div className="nav__main">
                    

                    <div onClick={() => {setOpenMenu(!openMenu)}}   className="nav_menu" >
                        <div className={`${'burger'} ${openMenu ? 'burgerActive' : ""}`}> </div>
                        

                    </div>
                </div>
            

            </div>

        </div>

        <AnimatePresence mode="wait">
        {openMenu && < NavMenu/>}
        </AnimatePresence>

        </>

    );

}

export default Nav;